import { UploadPage } from "@/features/upload/upload-page";

export function App() {
  return (
    <div className="flex min-h-screen flex-col bg-app">
      <header className="border-b border-ink/10 bg-app">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-4 sm:px-6 sm:py-5">
          <img src="/logo.svg" alt="Canotera" className="h-5 w-auto" />
          <span className="font-mono text-label uppercase text-tertiary">Secure upload</span>
        </div>
      </header>
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-8 sm:px-6 sm:py-10">
        <UploadPage />
      </main>
      <footer className="mt-auto border-t border-ink/10 py-5 text-center text-caption text-muted sm:py-6">
        <div className="mx-auto max-w-4xl space-y-2 px-4 sm:px-6">
          <p>
            <span className="font-mono text-label uppercase text-coral">Secure upload</span>
            {" — "}
            TLS encryption in transit · Email-verified access · Isolated storage per upload
          </p>
          <p>
            We handle your materials only to run your proof-of-concept. Delete anytime by emailing
            us, or we remove uploads after 14 days by default.{" "}
            <a
              href="https://canotera.com/legal/privacy"
              className="underline transition-colors duration-fast hover:text-primary"
            >
              Privacy
            </a>
            {" · "}
            <a
              href="mailto:support@canotera.com"
              className="underline transition-colors duration-fast hover:text-primary"
            >
              support@canotera.com
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
